import { Facebook, Twitter, Instagram, Mail, Phone, MapPin, Clock } from "lucide-react"

export default function Footer() {
  return (
    <footer id="footer" style={{ backgroundColor: 'var(--brand-red)', color: 'var(--white)' }}>
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company info */}
          <div>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-3)' }}>
              Tu casa de cambio de confianza en Mexicali. Ofrecemos las mejores tasas de cambio con 
              seguridad y transparencia garantizada.
            </p>
          </div>

          {/* Servicios */}
          <div>
            <h3 className="font-bold mb-4">Servicios</h3>
            <ul className="space-y-2 text-sm" style={{ color: 'var(--muted-3)' }}>
              <li>
                <a href="#" className="brand-link brand-muted-3">
                  Compra y Venta USD
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="font-bold mb-4">Contacto</h3>
            <ul className="space-y-3 text-sm" style={{ color: 'var(--muted-3)' }}>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>686 568 13 00</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Cuauhtémoc Norte 21200<br />Calz. Justo Sierra 211-A, Nueva, 21100 Mexicali, B.C</span>
              </li>
                <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Cuauhtémoc Norte 21200<br />Calz. Justo Sierra 18, Nueva, 21100 Mexicali, B.C.</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Lun - Sáb: 7:00 AM - 11:00 PM<br />Dom: 7:00 AM - 7:00 PM</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-bold mb-4">Suscríbete</h3>
            <p className="text-sm mb-4" style={{ color: 'var(--muted-3)' }}>
              Recibe las mejores tasas de cambio y noticias financieras directo en tu correo.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 px-4 py-2 rounded bg-white/10 border border-white/20 text-sm focus:outline-none input-focus"
              />
              <button className="p-2 rounded transition-colors" style={{ backgroundColor: 'var(--brand-gold)', color: 'var(--white)' }}>
                <Mail className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex gap-4">
            <a href="#" className="social-icon" style={{ color: 'var(--muted-3)' }}>
              <Facebook className="w-5 h-5" />
            </a>
            <a href="#" className="social-icon" style={{ color: 'var(--muted-3)' }}>
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" className="social-icon" style={{ color: 'var(--muted-3)' }}>
              <Twitter className="w-5 h-5" />
            </a>
          </div>

          <div className="flex gap-6 text-sm" style={{ color: 'var(--muted-3)' }}>
            <a href="#" className="hover:text-white transition-colors">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Aviso Legal
            </a>
          </div>
        </div>

        <div className="text-center mt-8 text-sm opacity-75">
          © 2025 Del Sol Centro Cambiario. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  )
}